$(document).ready(function() {
  $(".complete-the-look__products div.ctl-product:lt(3)").show();

  $(document).on('click', 'button.ctl-product__addToCart', function() {
      var $button = $(this);
      var $select = $button.parents('.ctl-product__info').find('.ctl-product__info-variant select');
      var $id = $select.val();
  
      var productData = {
          items: [
              {
                  id: $id,
                  quantity: 1
              }
          ]
      };
  
      $button.text('Adding...');
  
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: productData,
          dataType: 'json',
          success: function(response) {
              $button.text('Added!');
              setTimeout(function() {
                  $button.text("Add");
              }, 1000);
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
              console.log('Error al agregar el producto al carrito');
          }
      });
  });

  
});